// extracted by mini-css-extract-plugin
module.exports = {"notification":"TopHeaderForNotification-module--notification--3FZwq","show_notification":"TopHeaderForNotification-module--show_notification--3Y0u8"};